// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2Lvyg{display:flex;justify-content:center;align-items:center;flex-direction:column}._2Lvyg ._3KctE{border-radius:18px}._32oTf{margin-bottom:8px}\n", ""]);
// Exports
exports.locals = {
	"skeleton": "_2Lvyg",
	"button": "_3KctE",
	"middleLine": "_32oTf"
};
module.exports = exports;
